var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading-layer"},[_c('b-overlay',{attrs:{"show":"","spinner-variant":"primary","blur":_vm.blur,"opacity":_vm.opacity,"variant":_vm.variant,"rounded":_vm.rounded}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }